import moment from "moment";
import Space from "../../../components/Common/Space";
import Tooltip from "../../../components/Common/Tooltip";
import { MenuOutlined } from "@ant-design/icons";
import CustomActionMenu from "../../../components/CustomActionMenu/CustomActionMenu";
import StatusPill from "../../../components/Common/StatusPill";

export const INITIAL_STATE_HOSPITALIZACION_FORM = {
  tipoDocumento: "",
  documento: "",
  numeroIngreso: "",
  codigoPersonaHospitalizada: "",
  fechaIngreso: "",
  fechaSalida: "",
};

export const PACIENTES_INGRESADOS_ACTIONS = {
  VER_DETALLES: "ver_detalles",
  VALIDACION: "validacion",
};

export const actionsOptions = [
  { label: "Ver detalles", value: PACIENTES_INGRESADOS_ACTIONS.VER_DETALLES },
  {
    label: "Agregar Hoja QX",
    value: PACIENTES_INGRESADOS_ACTIONS.VALIDACION,
  },
];

export const procesarAccionPacienteIngresado = ({
  actionValue,
  record,
  historyPush,
}) => {
  const { numeroIngreso, nombreDelPaciente } = record;

  switch (actionValue) {
    case PACIENTES_INGRESADOS_ACTIONS.VER_DETALLES:
      return {
        type: "navigation",
        action: "VER_DETALLES",
        route: `/paciente-ingresado/${numeroIngreso}`,
        execute: () => historyPush(`/paciente-ingresado/${numeroIngreso}`),
        message: `Navegando a detalles de ${nombreDelPaciente}`,
      };

    case PACIENTES_INGRESADOS_ACTIONS.VALIDACION:
      return {
        type: "action",
        action: "VALIDACION",
        message: `Validar hoja QX de: ${nombreDelPaciente}`,
        execute: () => {},
        data: { paciente: nombreDelPaciente, tipo: "validacion" },
      };

    default:
      return {
        type: "unknown",
        action: "UNKNOWN",
        message: `Acción desconocida: ${actionValue}`,
        execute: () => console.warn("Acción desconocida:", actionValue),
        data: { action: actionValue },
      };
  }
};

const renderActionColumn = ({
  empresa,
  visibleActionsMenu,
  setVisibleActionsMenu,
  handleMenuClick,
  actionsOptions,
  record,
  colors,
}) => {
  const isVisible = visibleActionsMenu === record.numeroIngreso;

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Space size={10}>
        <div style={{ position: "relative" }}>
          <Tooltip text="Abrir menú">
            <MenuOutlined
              style={{
                color: empresa?.COLOR_PRINCIPAL,
                fontSize: 25,
                cursor: "pointer",
                position: "relative",
                zIndex: isVisible ? 1 : "auto",
              }}
              onClick={() => {
                setVisibleActionsMenu(isVisible ? null : record.numeroIngreso);
              }}
              data-testid="menu-outlined-icon"
            />
          </Tooltip>

          {isVisible && (
            <CustomActionMenu
              handleMenuClick={(action) => handleMenuClick(action, record)}
              options={actionsOptions}
              empresa={empresa}
              record={record}
              colors={colors}
              testid="custom-action-menu"
            />
          )}
        </div>
      </Space>
    </div>
  );
};

export const columnasPacientesIngresados = ({
  empresa,
  visibleActionsMenu,
  setVisibleActionsMenu,
  handleMenuClick,
  actionsOptions,
  colors,
}) => {
  return [
    {
      key: "numeroIngreso",
      title: "Número de ingreso",
      dataIndex: "numeroIngreso",
    },
    {
      key: "documento",
      title: "Cédula o Pasaporte",
      dataIndex: "documento",
    },
    {
      key: "codigoPersonaHospitalizada",
      title: "Número de asegurado",
      dataIndex: "codigoPersonaHospitalizada",
    },
    {
      key: "nombreDelPaciente",
      title: "Nombre del paciente",
      dataIndex: "nombreDelPaciente",
    },
    {
      key: "fechaIngreso",
      title: "Fecha de ingreso",
      dataIndex: "fechaIngreso",
      render: (fechaIngreso) =>
        fechaIngreso ? moment(fechaIngreso).format("DD/MM/YYYY") : "N/A",
    },
    {
      key: "fechaSalida",
      title: "Fecha de egreso",
      dataIndex: "fechaSalida",
      render: (fechaSalida) =>
        fechaSalida ? moment(fechaSalida).format("DD/MM/YYYY") : "N/A",
    },
    {
      key: "tieneHojaQx",
      title: "Tiene Hoja QX",
      dataIndex: "tieneHojaQx",
      align: "center",
      render: (tieneHojaQx) => {
        if (tieneHojaQx === "S") {
          return <StatusPill type="success" label="Si" />;
        }
        if (tieneHojaQx === "N") {
          return <StatusPill type="error" label="No" />;
        }
        return <StatusPill type="info" label="N/A" />;
      },
    },
    {
      key: "action",
      title: "Acción",
      align: "center",
      render: (_, record) =>
        renderActionColumn({
          empresa,
          visibleActionsMenu,
          setVisibleActionsMenu,
          handleMenuClick,
          actionsOptions,
          record,
          colors,
        }),
    },
  ];
};

export const construirParametrosFiltroPacientesIngresados = (params) => {
  if (!params) return "";

  const urlParams = new URLSearchParams();

  if (params.numeroIngreso) {
    urlParams.append("numeroIngreso", params.numeroIngreso);
  }
  if (params.codigoPersonaHospitalizada) {
    urlParams.append("codigoAsegurado", params.codigoPersonaHospitalizada);
  }
  if (params.documento) {
    urlParams.append("documento", params.documento);
  }
  if (params.fechaIngreso) {
    urlParams.append("fechaIngreso", params.fechaIngreso);
  }
  if (params.fechaSalida) {
    urlParams.append("fechaSalida", params.fechaSalida);
  }

  return urlParams.toString();
};

export const construirUrlPacientesIngresados = (
  numeroMedico,
  params,
  pagina,
  tamano
) => {
  const baseUrl = `api/v1/websalud/primeraars/hojaquirurgica/consultaingresospss?numeroMedico=${numeroMedico}`;
  const urlParams = new URLSearchParams();

  if (pagina) {
    urlParams.append("pagina", pagina);
  }
  if (tamano) {
    urlParams.append("tamano", tamano);
  }

  const queryString = construirParametrosFiltroPacientesIngresados(params);
  const paramsString = urlParams.toString();

  const fullQueryString =
    paramsString && queryString
      ? `${paramsString}&${queryString}`
      : paramsString || queryString;

  return fullQueryString ? `${baseUrl}&${fullQueryString}` : baseUrl;
};

